import { PageData } from 'actions/pageActions'
import { notFound } from 'next/navigation'
import {
  DEFAULT_EXPERIMENT,
  getPageVariationByParam,
  UNASSIGNED_EXPERIMENT,
} from 'constants/experiments'
import { ContentfulSection } from '@/app/contentful/contenfulTypes'
import { SearchParams } from 'utils/headerManager/headerManager'

export type ExperimentVariation = {
  id: string | undefined
  name: string | undefined
  variation: string | undefined
}

export type ExperimentData = {
  pageVariation: ExperimentVariation | null
  pageSectionsVariations: ExperimentVariation[]
  quizPage: string | undefined
  quizName: string | undefined
}

export function getExperimentData(pageProps: PageData, query: SearchParams): ExperimentData {
  if (pageProps?.notFound) {
    notFound()
  }

  // Get the featureFlagId of the page which represents the feature flag name
  const featureFlagId = pageProps?.content?.fields?.experiment?.featureFlagId
  // Get the variation:
  // 1. If the variation is coming from query params in the browser url use that
  // 2. Otherwise get the assigned value from LD
  const experimentToggle = query?.v
    ? getPageVariationByParam(query?.v)
    : featureFlagId
    ? pageProps?.featureToggleObject?.[featureFlagId]
    : undefined

  // Creates an object containing experiment data for tracking if these conditions are met:
  // 1. The experimentToggle matches the current pages experiment variaton field
  // 2. Or if experimentToggle is unassigned and the current pages experiment variation field is control
  let pageVariation =
    experimentToggle === pageProps?.content?.fields?.experimentVariation ||
    (experimentToggle === UNASSIGNED_EXPERIMENT &&
      pageProps?.content?.fields?.experimentVariation === DEFAULT_EXPERIMENT)
      ? {
          id: pageProps?.content?.fields?.experiment?.featureFlagId,
          name: pageProps?.content?.fields?.experiment?.name,
          variation: experimentToggle,
        }
      : null

  const pageSectionsVariations: ExperimentVariation[] = []
  let quizName
  let quizPage
  pageProps?.content?.fields?.sections?.forEach((section: ContentfulSection) => {
    if (section?.fields?.uiComponent === 'DebtQuiz') {
      quizName = section?.fields?.name
      quizPage = `${section?.fields?.name} - Landing Page`
    }
    const sectionFeatureFlagId = section?.fields?.experiment?.featureFlagId
    if (sectionFeatureFlagId) {
      let experimentToggleSection = pageProps?.featureToggleObject?.[sectionFeatureFlagId]

      experimentToggleSection = query?.[`v-${sectionFeatureFlagId}`]
        ? getPageVariationByParam(query?.[`v-${sectionFeatureFlagId}`])
        : experimentToggleSection

      if (query?.[`v-${sectionFeatureFlagId}`]) {
        pageProps.featureToggleObject[sectionFeatureFlagId] = getPageVariationByParam(
          query?.[`v-${sectionFeatureFlagId}`]
        )
      }

      const pageSectionVariation = Boolean(
        section?.fields?.experimentVariation === experimentToggleSection ||
          (section?.fields?.experimentVariation === DEFAULT_EXPERIMENT &&
            experimentToggleSection === UNASSIGNED_EXPERIMENT)
      )

      if (
        section?.fields?.experiment?.pageLevelExperiment &&
        (pageSectionVariation || query?.[`v-${sectionFeatureFlagId}`])
      ) {
        pageVariation = {
          id: sectionFeatureFlagId,
          name: section?.fields?.experiment?.name,
          variation: experimentToggleSection,
        }
      } else if (pageSectionVariation) {
        pageSectionsVariations.push({
          id: sectionFeatureFlagId,
          name: section?.fields?.experiment?.name,
          variation: experimentToggleSection,
        })
      }
    }
  })

  return { quizName, quizPage, pageVariation, pageSectionsVariations }
}
